import DashboardLayout from "../../layout/DashboardLayout";
import AddBooks from "../AddBooks/AddBooks";
import Books from "../Books/Books";
import CategoryBooks from "../Home/Catagories/CategoryBooks/CategoryBooks";
import Login from "../Home/Login/Login";
import Block from "../Home/Share/Block/Block";
import DisplayError from "../Home/Share/DisplayError/DisplayError";
import ErrorPage from "../Home/Share/ErrorPage/ErrorPage";
import Signup from "../Home/Signup/Signup";
import AllBuyer from "./Dashboard/AllBuyer/AllBuyer";
import AllSeller from "./Dashboard/AllSeller/AllSeller";
import AllUser from "./Dashboard/AllUser/AllUser";
import MyOrder from "./Dashboard/MyOrder/MyOrder";


import MyProducts from "./Dashboard/MyProducts";
import Payment from "./Dashboard/payment/Payment";
import PrivateRoute from "./PrivateRoute/PrivateRoute";

const { createBrowserRouter } = require("react-router-dom");
const { default: Main } = require("../../layout/Main");
const { default: Home } = require("../Home/Home");

const router = createBrowserRouter([
    {
        path: '/',
        element: <Main></Main>,
        errorElement: <DisplayError></DisplayError>,
        children: [
            {
                path: '/', element: <Home></Home>
            },
            {
                path: '/login', element: <Login></Login>
            },
            {
                path: '/signup', element: <Signup></Signup>
            },

            {
                path: '/category/:id',
                element: <Books></Books>,
                loader: ({ params }) => fetch(`https://assignment-12-server-beige.vercel.app/confirmbooking/i/${params.id}`)

            },


            // {
            //     path: '/category/:id', element: <CategoryBooks></CategoryBooks>,
            //     loader: ({ params }) => fetch(`https://assignment-12-server-imraniium-su.vercel.app/category/${params.id}`)
            // },
            {
                path: '/block', element: <Block></Block>
            }
        ]
    },
    {
        path: '/dashboard',
        element: <PrivateRoute><DashboardLayout></DashboardLayout></PrivateRoute>,

        children: [
            {
                path: '/dashboard/myproducts', element: <MyProducts></MyProducts>
            },
            {
                path: '/dashboard/myorder', element: <MyOrder></MyOrder>
            },
            {
                path: '/dashboard/addbooks', element: <AddBooks></AddBooks>
            },
            {
                path: '/dashboard/allseller', element: <AllSeller></AllSeller>
            },
            {
                path: '/dashboard/allbuyer', element: <AllBuyer></AllBuyer>
            },
            {
                path: '/dashboard/alluser', element: <AllUser></AllUser>
            },
            {
                path: '/dashboard/payment/:id', element: <Payment></Payment>,
                loader: ({ params }) => fetch(`https://assignment-12-server-imraniium-su.vercel.app/bookings/${params.id}`)
            }



        ]
    },
    {
        path: '*', element: <ErrorPage></ErrorPage>
    }
])


export default router;